import { gsap } from 'gsap';

export function circularButtonInit(el) {
  const content = el.querySelector('[data-icon]');

  gsap.set([el, content], { scale: 0, transformOrigin: '50% 50%' });
}

export function circularButtonEnter(el) {
  const content = el.querySelector('[data-icon]');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to([el, content], {
      scale: 1,
      ease: 'bloom',
      stagger: 0.3,
      duration: 1.2,
    }, 'start');

  return tl;
}

export function circularButtonLeave(el) {
  el.removeAttribute('data-animated');
  const tween = gsap.to(el, {
    scale: 0,
  });

  return tween;
}
